module.exports = __webpack_public_path__ + "img/G3.48723740.jpg";